<template>
  <div id="reasonInputModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body" style="width: 100%;text-align: left">
        <div class="condition-area">
          <table class="conditionTable">
            <tr v-if="isHolterAnalysis">
              <th style="vertical-align:top;text-align:left;width:15%;">却下箇所</th>
            </tr>
            <tr v-if="isHolterAnalysis">
              <td>
                <select name="dismissal">
                <option></option>
                <option value="1">解析結果を却下</option>
                <option  v-if="isJudgement" value="2">判定結果を却下</option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align:top;text-align:left;width:15%;">理由</th>
            </tr>
            <tr>
              <td><textarea v-model="reason" maxlength="256" style="resize:vertical;width:100%;max-width:100%;height:300px;"></textarea></td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="reason.length==0">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "reasonInputModal",
  props:["title","isHolterAnalysis","isJudgement"],
  methods: {
    save: function() {
      if(this.reason.replaceAll(" ","").replaceAll("　","").length == 0){
        this.showMessage('理由が入力されていません。');
        return
      }
      this.$parent.close();
      this.$emit('setReason', this.reason);
    }
  },
  data() {
    return {
      reason:""
    };
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/reasonInputModal.vue